import type { ApiFile } from "./interfaces";

/**
 * The `fileUrl` an attachment chip carries until the server describes its file: an upload
 * still in flight (useSendMessageMutation) or a file a thread's address names
 * (useCreateConversationAndNavigate). No bytes are behind it, and a file id read from a link
 * is not the server's word that this reader may open that file.
 */
export const PENDING_FILE_URL = "NA";

/** Whether the server has described this file: it carries a URL, and not the stand-in. */
export function hasServerFileUrl(file: Pick<ApiFile, "fileUrl">): boolean {
    return !!file.fileUrl && file.fileUrl !== PENDING_FILE_URL;
}
